<template>
  <withTopNav :leftText="$t('Registro.LeftText')" fixed>
    <div class="w-full h-full relative">
      <div class="registro flex flex-col h-[100vh]">
        <div class="flex justify-center mt-6 px-[20px] text-[12px]">
          <div
            @click="handleTabChange('1')"
            :class="[
              'text-white  py-[14px] text-center w-[50%] rounded-l-lg bg-[#2C7952]/40',
              { '!bg-[#2C7952]': activeKey === '1' },
            ]"
          >
            {{ $t('Registro.AccountRegistration') }}
          </div>
          <div
            @click="handleTabChange('2')"
            :class="[
              'text-white py-[14px] text-center w-[50%] rounded-r-lg bg-[#2C7952]/40',
              { '!bg-[#2C7952]': activeKey === '2' },
            ]"
          >
            {{ $t('Registro.BettingRecords') }}
            
          </div>
        </div>
        <div
          id="tab1"
          ref="scrollableDiv1"
          v-show="activeKey === '1'"
          class="flex-1 flex flex-col overflow-hidden overflow-y-auto px-[20px]"
        >
          <div>
            <div>
              <div class="w-full text-[#fff] mt-6 rounded-[10px]">
                <div
                  class="flex mb-[2px] p-[12px] bg-[#2C7952]/70 rounded-t-[8px]"
                  @click="isOpen = true"
                >
                  <span class="flex-1 ml-[5px]">
                    {{ options.find((item) => item.values === timeRange1)?.text }}
                  </span>
                  <div class="flex items-center">
                    <span class="text-[#fff]">{{ $t('Registro.Filter') }}</span>
                    <img
                      :src="downArrowIcon"
                      :class="['w-[12px] h-[6px] ml-2', { 'rotate-180': isOpen }]"
                    />
                  </div>
                </div>
                <div class="w-full flex flex-wrap gap-y-[1px] gap-x-[1px]">
                  <div
                    class="w-[33%] h-[82px] bg-[#2C7952]/40 flex flex-col justify-center items-center text-[12px]"
                  >
                    <span class="text-[#fff] text-[16px] font-bold">
                      {{
                        formatter().format(
                          walletFlowCount?.total ? walletFlowCount.total : 0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[13px]">{{ $t('Registro.All') }}</span>
                  </div>
                  <div
                    v-for="(item, index) in types"
                    :key="item.values"
                    :class="[
                      'w-[33%] h-[82px] bg-[#2C7952]/20 flex flex-col justify-center items-center text-[12px]',
                      {
                        'rounded-bl-[10px]': index === 2,
                        'bg-[#2C7952]/40': index < 2,
                        'rounded-br-[10px]': index === 4,
                      },
                    ]"
                  >
                    <span class="text-[#fff] text-[16px] font-bold">
                      {{
                        formatter().format(
                          walletFlowCount[item.values.toLocaleLowerCase()]
                            ? walletFlowCount[item.values.toLocaleLowerCase()]
                            : 0
                        )
                      }}
                    </span>
                    <span class="text-[#fff]/50 text-[13px]">{{ item.buttonText }}</span>
                  </div>
                </div>
              </div>

              <template v-if="walletFlowList.length">
                <van-list
                  v-model:loading="loading"
                  :finished="hasMore"
                  :finished-text="$t('Registro.NoMoreData')"
                  :loading-text="$t('Common.Loading')"
                  @load="loadMore"
                >
                  <div
                    v-for="(item, index) in walletFlowList"
                    :key="index"
                    @click="
                      () => {
                        showWalletFlowDetail = true;
                        walletFlowItem = item;
                      }
                    "
                    class="w-full bg-[#2C7952]/40 p-[10px] rounded-[10px] mt-[10px] flex items-center"
                  >
                    <div class="flex-1 mr-[5px] text-[#fff]">
                      <div class="flex justify-between items-center text-[15px]">
                        <span>{{ flowTypes[item.type]?.text }}</span>
                        <div class="flex items-center justify-end min-w-[120px]">
                          <span
                            >{{ Number(item.amount) > 0 ? "+" : "" }}
                            {{ formatter().format(item.amount) }}</span
                          >
                          <img
                            :src="downArrowIcon"
                            class="w-[12px] h-[6px] ml-2"
                            style="transform: rotate(-90deg)"
                          />
                        </div>
                      </div>
                      <div
                        class="flex justify-between items-center text-[#fff]/50 text-[12px] mt-[10px]"
                      >
                        <div class="flex">
                          <span
                            class="block w-[120px] whitespace-nowrap overflow-hidden text-ellipsis"
                            >{{ item.id }}</span
                          >
                          <img
                            :src="copy"
                            class="w-[20px] h-[20px] ml-[15px]"
                            @click.stop="copyText(item.id)"
                          />
                        </div>
                        <span>{{
                          dayjs(item.createTime).format("YYYY-MM-DD HH:mm:ss")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </van-list>
              </template>
              <template v-else>
                <NoData
                  :text="$t('Registro.NoRecordsYet') + $t('Registro.NoAccountRecords')"
                />
              </template>
            </div>
          </div>
        </div>
        <div
          id="tab2"
          ref="scrollableDiv2"
          v-show="activeKey === '2'"
          class="flex-1 flex flex-col overflow-hidden overflow-y-auto px-[20px]"
        >
          <div>
            <div class="w-full text-[#fff] mt-6 rounded-[10px]">
              <div
                class="flex mb-[2px] p-[12px] bg-[#2C7952]/70 rounded-t-[8px]"
                @click="isOpen = true"
              >
                <span class="flex-1 ml-[5px]">
                  {{ options.find((item) => item.values === timeRange2)?.text }}
                </span>
                <div class="flex items-center">
                  <span class="text-[#fff]">{{ $t('Registro.Filter') }}</span>
                  <img
                    :src="downArrowIcon"
                    :class="['w-[12px] h-[6px] ml-2', { 'rotate-180': isOpen }]"
                  />
                </div>
              </div>
              <div class="flex justify-between leading-[20px] rounded-[8px]">
                <div
                  class="p-[12px] flex-1 flex flex-col justify-center items-center rounded-bl-[10px] bg-[#2C7952]/40"
                >
                  <span class="block mb-[5px] text-[#fff] text-[15px] font-bold">
                    {{
                      formatter().format(
                        dataList?.totalBetAmount ? dataList.totalBetAmount : 0
                      )
                    }}
                  </span>
                  <span class="text-[#FFFFFF]/50 text-[13px]"
                    >{{ $t('Registro.Bet') }}
                    {{ dataList?.totalBetTimes ? dataList.totalBetTimes : 0 }} {{ $t('Registro.Times') }}</span
                  >
                </div>
                <div
                  class="ml-[1px] p-[12px] flex-1 flex flex-col justify-center items-center rounded-br-[10px] bg-[#2C7952]/40"
                >
                  <span class="block mb-[5px] text-[#fff] text-[15px] font-bold">
                    {{
                      formatter().format(
                        dataList?.totalWinLoss ? dataList.totalWinLoss : 0
                      )
                    }}
                  </span>
                  <span class="text-[#FFFFFF]/50 text-[13px]">{{ $t('Registro.WinOrLose') }}</span>
                </div>
              </div>
            </div>
            <template v-if="gameRecordCountList.length">
              <div class="overflow-hidden">
                <van-list
                  v-model:loading="loading"
                  :finished="hasMoreRecord"
                  finished-text="{{ $t('Registro.NoMoreData') }}"
                  :loading-text="$t('Common.Loading')"
                  @load="getRecordListData"
                >
                  <div
                    v-for="(item, index) in gameRecordCountList"
                    :key="index"
                    @click="
                      () => {
                        showGameDetail = true;
                        gameItem = {
                          timeRange: timeRange2,
                          timeRangeObj: getTimeRange(timeRange2),
                          ...item,
                        };
                      }
                    "
                    class="w-full bg-[#2C7952]/40 p-[10px] rounded-[10px] mt-[10px] flex items-center"
                  >
                    <Image class="size-[51px]" :src="item.icon" alt="" />
                    <div class="flex-1 px-[10px]">
                      <div
                        class="flex text-[15px] justify-between items-center text-[#fff]"
                      >
                        <span>{{ item.name }}</span>
                        <div class="flex items-center">
                          <span>{{ formatter().format(item.totalWinLoss) }}</span>
                          <img
                            :src="downArrowIcon"
                            class="w-[12px] h-[6px] ml-2"
                            style="transform: rotate(-90deg)"
                          />
                        </div>
                      </div>
                      <div
                        class="flex justify-between items-center text-[#FFFFFFBF] text-[12px] mt-[10px]"
                      >
                        <span
                          >{{ $t('Registro.Turnover') }} {{ formatter().format(item.totalBetAmount) }}</span
                        >
                        <span>{{ item.totalBetTimes }} {{ $t('Registro.Times') }}</span>
                      </div>
                    </div>
                  </div>
                </van-list>
              </div>
            </template>
            <template v-else>
              <NoData
                :text="$t('Registro.NoRecordsYet') + $t('Registro.NoBettingRecords')"
              />
            </template>
          </div>
        </div>
        <!-- 筛选弹窗 -->
        <van-popup
          v-model:show="isOpen"
          position="bottom"
          :style="{
            height: activeKey === '1' ? '560px' : '370px',
          }"
        >
          <div class="w-full h-full bg-[#151A1F] overflow-auto">
            <div
              class="w-full h-[44px] text-[15px] flex justify-center items-center bg-[#2F5C41] text-[#fff] sticky top-0 rounded-t-[10px]"
            >
              <span>{{ $t('Registro.FilterConditions') }}</span>
            </div>
            <div class="w-full">
              <p class="text-[#fff] text-[15px] mt-[10px] px-[40px]">{{ $t('Registro.SelectTime') }}</p>
              <div
                class="px-[40px] flex justify-between flex-wrap mt-[10px] gap-y-[10px]"
              >
                <button
                  v-for="item in options"
                  :key="item.values"
                  @click="
                    () => {
                      timeRange = item.values;
                      if (activeKey === '1') {
                        timeRange1 = item.values;
                      } else {
                        timeRange2 = item.values;
                      }
                    }
                  "
                  :class="[
                    'w-[140px] h-[44px] text-[13px] rounded-[8px] border-0',
                    timeRange === item.values
                      ? 'bg-[#2C7952]/40 text-[#fff]'
                      : 'bg-[#2C7952]/20 text-[#fff]/65',
                  ]"
                >
                  {{ item.buttonText }}
                </button>
              </div>
              <template v-if="activeKey === '1'">
                <p class="text-[#fff] text-[15px] mt-[10px] px-[40px]">{{ $t('Registro.SelectType') }}</p>
                <div
                  class="px-[40px] flex justify-between flex-wrap mt-[10px] gap-y-[10px]"
                >
                  <div
                    v-for="item in types"
                    :key="item.values"
                    class="w-[140px] h-[44px] relative rounded-[8px] overflow-hidden"
                    @click="
                      () => {
                        if (typesArr.includes(item.values)) {
                          const newArr = typesArr.filter((ele) => ele !== item.values);
                          typesArr = newArr;
                        } else {
                          typesArr = [...typesArr, item.values];
                        }
                      }
                    "
                  >
                    <button
                      :class="[
                        'w-[150px] h-[44px] text-[13px] rounded-[8px] border-0',
                        typesArr.includes(item.values)
                          ? 'bg-[#2C7952]/40 text-[#fff]'
                          : 'bg-[#2C7952]/20 text-[#fff]/65',
                      ]"
                    >
                      {{ item.buttonText }}
                    </button>
                    <div
                      :class="[
                        'w-[20px] h-[20px] absolute top-[12px] right-[5px] rounded-full flex items-center justify-center',
                        typesArr.includes(item.values)
                          ? 'bg-[#0BCF33]'
                          : 'bg-[#FFFFFF80]',
                      ]"
                    >
                      <span class="text-[10px] text-[#fff]">✓</span>
                    </div>
                  </div>
                </div>
              </template>
              <div class="px-[40px] flex justify-between mb-[30px]">
                <button
                  class="border border-[#fff] w-[140px] h-[45px] text-white/85 text-[15px] bg-[#151A1F] rounded-[10px] mt-[45px]"
                  @click="cancel"
                >
                  {{ t('Common.Cancel') }}
                </button>
                <button
                  class="w-[140px] h-[45px] text-[#151A1F] text-[15px] bg-[#64F765] rounded-[10px] mt-[45px]"
                  @click="
                    () => {
                      if (activeKey === '1') {
                        current = 0;
                        walletFlowList = [];
                        getWalletFlow(current, getTimeRange(timeRange1));
                        getCount(getTimeRange(timeRange1));
                      } else {
                        currentRecord = 0;
                        gameRecordCountList = [];
                        getRecordListData(getTimeRange(timeRange2));
                        getRecordCountData(getTimeRange(timeRange2));
                      }
                      isOpen = false;
                    }
                  "
                >
                  {{ t('Common.Confirm') }}
                </button>
              </div>
            </div>
          </div>
        </van-popup>
      </div>
      <template v-if="showWalletFlowDetail">
        <WalletFlowDetail
          @close="
            () => {
              showWalletFlowDetail = false;
            }
          "
          :walletFlowItem="walletFlowItem"
        ></WalletFlowDetail>
      </template>
      <template v-if="showGameDetail">
        <GameDetail
          @close="
            () => {
              showGameDetail = false;
            }
          "
          :gameItem="gameItem"
        ></GameDetail>
      </template>
    </div>
  </withTopNav>
</template>

<script setup lang="ts">
import { useEventListener } from "@vueuse/core";
import {
  getRecordList,
  getWalletFlowList,
  getWalletFlowSummary,
  getRecordCount,
} from "@/api/registro";
import debounce from "lodash-es/debounce";
import { formatter } from "@/utils";
import downArrowIcon from "./images/downArrowIcon.png";
import NoData from "@/components/NoData/index.vue";
import copy from "./images/copy.png";
import dayjs from "dayjs";
import { copyText } from "@/utils";
import WalletFlowDetail from "./compontents/WalletFlowDetail.vue";
import GameDetail from "./compontents/GameDetail.vue";
import withTopNav from "@/layouts/withTopNav.vue";
import i18n from "@/i18n";
const t = i18n.global.t;
import { getLabel } from "./constants";
// import { options, types, flowTypes } from "./constants";
const { options, types, flowTypes } = getLabel(t);
const activeKey = ref<string>("1");
const walletFlowCount = ref<any>({});
const walletFlowList = ref<any[]>([]);
const timeRange = ref<number>(1);
const timeRange1 = ref<number>(1);
const timeRange2 = ref<number>(1);
const isOpen = ref<boolean>(false);
const showWalletFlowDetail = ref<boolean>(false);
const walletFlowItem = ref<any>({});
const hasMore = ref<boolean>(false);
const current = ref<number>(0);
const currentRecord = ref<number>(0);
const typesArr = ref<any>(["Deposit", "Withdrawal"]);
const scrollPositions = ref({ tab1: 0, tab2: 0 });
const scrollableDiv1 = ref<any>(null);
const scrollableDiv2 = ref<any>(null);
const hasRunInitFn1 = ref<boolean>(false);
const hasRunInitFn2 = ref<boolean>(false);
const gameRecordCountList = ref<any>([]);
const dataList = ref<any>({});
const loading = ref<boolean>(false);
const showGameDetail = ref<boolean>(false);
const gameItem = ref<any>(null);
const templetData = ref<any>({});
const hasMoreRecord = ref<boolean>(false);
const cancel = () => {
  timeRange.value = templetData.value.timeRange;
  typesArr.value = templetData.value.typesArr;
  if (activeKey.value === "1") {
    timeRange1.value = templetData.value.timeRange;
  } else {
    timeRange2.value = templetData.value.timeRange;
  }
  isOpen.value = false;
};

useEventListener(scrollableDiv1, "scroll", (event: any) => {
  scrollPositions.value.tab1 = event.target?.scrollTop;
});
useEventListener(scrollableDiv2, "scroll", (event: any) => {
  scrollPositions.value.tab2 = event.target?.scrollTop;
});

const loadMore = debounce(async () => {
  const timeRangeObj: any = getTimeRange(timeRange1.value);
  const formData = new FormData();
  formData.append("startTime", timeRangeObj?.startTime);
  formData.append("endTime", timeRangeObj?.endTime);
  formData.append("flowCategory", typesArr.value.join(","));
  formData.append("pageIndex", (++current.value).toString());
  const params = new URLSearchParams(formData as any);
  const res = await getWalletFlowList(params);
  loading.value = false;

  walletFlowList.value = [...walletFlowList.value, ...res.data.data];

  if (walletFlowList.value.length >= res.data.total) {
    hasMore.value = true;
  }
}, 300);

// 切换 Tab 前，保存当前 Tab 的滚动位置
const handleTabChange = (key: string) => {
  activeKey.value = key;
  const currentTabContent = document.getElementById(`tab${key}`);
  if (currentTabContent) {
    currentTabContent.scrollTop = scrollPositions.value[`tab${key}`];
  }
};

// 获取账变记录
const getWalletFlow = async (page, timeRangeObj) => {
  const formData = new FormData();
  formData.append("startTime", timeRangeObj?.startTime);
  formData.append("endTime", timeRangeObj?.endTime);
  formData.append("flowCategory", typesArr.value.join(","));
  formData.append("pageIndex", page);
  const params = new URLSearchParams(formData as any);
  const { code, data } = await getWalletFlowList(params);
  if (code === 1) {
    walletFlowList.value = data.data;
    loading.value = false;
    hasMore.value = walletFlowList.value.length >= Number(data.total);
  }
};
// 获取投注记录统计
const getRecordCountData = async (timeRangeObj) => {
  const { code, data } = await getRecordCount({
    startTime: timeRangeObj?.startTime,
    endTime: timeRangeObj?.endTime,
  });
  if (code === 1) {
    dataList.value = data || {};
  }
};
// 获取投注记录
const getRecordListData = async (timeRangeObj) => {
  const { code, data } = await getRecordList({
    startTime: timeRangeObj?.startTime,
    endTime: timeRangeObj?.endTime,
    pageIndex: (currentRecord.value++).toString(),
  });
  if (code === 1) {
    gameRecordCountList.value = [...gameRecordCountList.value, ...data.data];
    if (gameRecordCountList.value.length >= Number(data.total)) {
      hasMoreRecord.value = true;
    }
  }
};
// 获取账变记录统计数
const getCount = async (timeRangeObj) => {
  const formData = new FormData();
  formData.append("startTime", timeRangeObj?.startTime);
  formData.append("endTime", timeRangeObj?.endTime);
  formData.append("flowCategory", typesArr.value.join(","));
  const params = new URLSearchParams(formData as any);
  const { code, data } = await getWalletFlowSummary(params);
  if (code === 1) {
    walletFlowCount.value = data || {};
  }
};

watch(isOpen, (newVal) => {
  templetData.value = {
    timeRange: timeRange.value,
    typesArr: typesArr.value,
  };
});
watch(activeKey, (newVal) => {
  if (newVal === "1") {
    if (!hasRunInitFn1.value) {
      timeRange.value = 1;
      hasRunInitFn1.value = true;
      getWalletFlow(current.value, getTimeRange(timeRange1.value));
      getCount(getTimeRange(1));
    } else {
      timeRange.value = timeRange1.value;
    }
  } else {
    if (!hasRunInitFn2.value) {
      timeRange.value = 1;
      hasRunInitFn2.value = true;
      getRecordListData(getTimeRange(1));
      getRecordCountData(getTimeRange(1));
    } else {
      timeRange.value = timeRange2.value;
    }
  }
});

// 客户端时间
const getTimeRange = (timeRange = 1) => {
  const todayStartTime = dayjs().format("YYYY-MM-DD 00:00:00");
  // utc时间
  const utcStartTime = dayjs(todayStartTime).utc().valueOf();
  const utcEndTime = utcStartTime + 24 * 60 * 60 * 1000;

  switch (timeRange) {
    // 今天
    case 1:
      return {
        startTime: utcStartTime,
        endTime: utcEndTime,
      };
    // 昨天
    case 2:
      return {
        startTime: dayjs(utcStartTime).subtract(1, "day").valueOf(),
        endTime: dayjs(utcEndTime).subtract(1, "day").valueOf(),
      };
    // 近7天
    case 3:
      return {
        startTime: dayjs(utcStartTime).subtract(6, "day").valueOf(),
        endTime: utcEndTime,
      };
    // 近15天
    case 4:
      return {
        startTime: dayjs(utcStartTime).subtract(14, "day").valueOf(),
        endTime: utcEndTime,
      };
    // 近30天
    case 5:
      return {
        startTime: dayjs(utcStartTime).subtract(29, "day").valueOf(),
        endTime: utcEndTime,
      };
    default:
      break;
  }
};

onMounted(() => {
  timeRange.value = 1;
  hasRunInitFn1.value = true;
  getWalletFlow(current.value, getTimeRange(timeRange1.value));
  getCount(getTimeRange(1));
});
</script>

<style lang="scss" scoped></style>
